$( document ).ready(function() {
/**
 * Footer Menu
*/          

$(".section-footer__menu-block .section-footer__title").click(function (event) {
    let width = window.innerWidth;
    $(this).toggleClass('active');
    if (width < 768) {
      $(this).next(".section-footer__menu-block__menu").slideToggle("fade", function () { });
    }
  });
  
/**
 Header right menu
*/
  $('.logo-area__right__inner .navigation__link').on('mouseover', function() {
    let nav_right = $(this).attr('aria-controls');
    let nav_id;
    nav_id = '#' + nav_right;
    let ul_list =  $('#main-nav  .navigation__tier-1 > li.navigation__item--with-children');
     for( let i=0;i< ul_list.length; i++) {
      let t = ul_list[i];
      if (typeof nav_right !== 'undefined' && nav_right !== false) {
      $(t).find(nav_id).parent().addClass('navigation__item--show-children');
      $(t).find(nav_id).addClass('nav_right_col');
      } else {
        if($(t).hasClass('navigation__item--show-children') === true) {
          $(t).removeClass('navigation__item--show-children');
        }
      }
     }
  });

  $('.menu-promotion__link').on('click', function(e) {
    e.preventDefault();
    console.log('clicked');
  });
  
  function activateCarousel(){
  console.log('owl reached');
  $('#recommended-slider1').toggleClass('test', true);
  console.log('test')
    // $('.related-collection .product-list').addClass('owl-carousel').addClass('owl-theme');
    // $('.related-collection .product-list').owlCarousel({
    //   loop: false,
    //   dots: true,
    //   autoWidth:false,
    //   autoHeight: true,
    //   items:3,
    //   nav: false,
    //   responsive: {
    //     0: {
    //       items: 1
    //     },
    //     751: {
    //       items: 2
    //     }, 
    //     1100: {
    //       items: 3
    //     }
    //   }
    // });
  }
// $(document).ready(function(){
//  activateCarousel();
//  $('#recommended-slider1').toggleClass('test', false);
// });


$('.first__question--column').wrapAll('<div class="first__question--column-wrapper question__column--wrapper" />')
$('.second__question--column').wrapAll('<div class="second__question--column-wrapper question__column--wrapper" />')
$('.question__column--wrapper').wrapAll('<div class="question__column--wrapper-container" />')
$('.afterpay-text1').text('4 interest-free installments of');
  
});



